import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";
import Choices from 'choices.js'

export default class extends Controller {
  static targets = ["BolForm", "SupplierSelect", "SupplierName", "SupplierCompany", "SupplierPhone", "SupplierStreet", "SupplierCity", "SupplierState", "SupplierZipcode", "SupplierId", "SupplierResidentialPickup", "SupplierLiftgatePickup", "PoNumberInput", "EmailSubjectInput", "EmailBodyInput", "EmailPoIdsInput", "PickupDateInput", "supplierEmailInput", "TotalWeightPallets1"];

  connect() {
    this.element[this.identifier] = this;
    this.emailPoIdsChoices = new Choices(this.EmailPoIdsInputTarget);

    window.addEventListener("click", this.onBgClick.bind(this));
  }

  onBgClick(e) {
    const elems = document.querySelectorAll('[data-controller="form-resource-search"]');
    elems.forEach((elem) => {
      const controllerElem = this.application.getControllerForElementAndIdentifier(elem, "form-resource-search");
      controllerElem.hideResults();
    });
  }

  onSupplierChange(e) {
    this.supplierEmailInputTarget.value = e.target.value;
  }

  onFillData(data, resourceType) {
    if (resourceType == "supplier") {
      this.onFillSupplierData(data);
    }
  }

  onFillSupplierData(supplier) {
    this.SupplierCompanyTarget.value = supplier.name;
    this.SupplierPhoneTarget.value = supplier.phone_number
      .replace("+1", "")
      .replace(/^1/, "")
      .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    this.SupplierStreetTarget.value = supplier.address;
    this.SupplierCityTarget.value = supplier.city;
    this.SupplierStateTarget.value = supplier.state;
    this.SupplierZipcodeTarget.value = supplier.zipcode;
    this.SupplierIdTarget.value = supplier.id;

    if (supplier.business_type == "business") {
      this.SupplierResidentialPickupTarget.checked = false;
    } else {
      this.SupplierResidentialPickupTarget.checked = false;
    }

    if (supplier.loading_option_forklift == false && supplier.loading_option_loading_dock == false) {
      this.SupplierLiftgatePickupTarget.checked = true;
    } else {
      this.SupplierLiftgatePickupTarget.checked = false;
    }
  }

  onPoChange(e) {
    const selectedOption = e.target.options[e.target.selectedIndex]
    const poId = selectedOption.dataset.poId
    const poNumber = selectedOption.dataset.poNumber

    this.PoNumberInputTarget.value = `PO # ${poNumber}`;
    let emailSubject = this.EmailSubjectInputTarget.value;
    const regex = /(PO\s*#?\s*)(\d+)/;
    const match = emailSubject.match(regex);
    if (match) {
      const startIndex = emailSubject.indexOf(match[0]);
      emailSubject = emailSubject.substring(0, startIndex) + `PO ${poNumber}`;
    } else {
      emailSubject += ` PO ${poNumber}`;
    }
    this.EmailSubjectInputTarget.value = emailSubject;

    this.emailPoIdsChoices.removeActiveItems();
    this.emailPoIdsChoices.setChoiceByValue(poId)

    const totalWeight = selectedOption.dataset.totalWeight;
    this.TotalWeightPallets1Target.value = (parseFloat(totalWeight) + 35.0).toFixed(1);
  }

  onPickupDateChange(e) {
    const pickupDate = e.currentTarget.value;
    const dateObj = new Date(pickupDate);

    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayName = days[dateObj.getDay()];
    const month = dateObj.getMonth() + 1; // Months are zero-indexed
    const day = dateObj.getDate();

    const bolPoNumber = this.PoNumberInputTarget.value;
    const formattedPoNumber = bolPoNumber.replace("#", "").replace("PO ", "").replace("  ", " ").split(" ").join(" ");

    const emailSubject = `[${dayName} ${month}/${day}] Shipping BOL for PO${formattedPoNumber}`;
    this.EmailSubjectInputTarget.value = emailSubject;
    let emailBody = this.EmailBodyInputTarget.value;
    emailBody = emailBody.replace(/(for\s*)(today|tomorrow|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)(,\s*)(\d+\/\d+)/, `$1${dayName}, ${month}/${day}`)

    this.EmailBodyInputTarget.value = emailBody
  }

  onUpdatePickupTime(e) {
    const pickupTime1 = e.currentTarget.value;
    Cookies.set("bol_form_pickup_time_1", pickupTime1);
  }

  onUpdatePickupInstructions(e) {
    const pickupInstructions = e.currentTarget.value;
    Cookies.set("bol_form_pickup_instructions", pickupInstructions);
  }

  onBookAndEmailSupplier(e) {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.disabled = true;
    const form = this.BolFormTarget;
    form.action = e.currentTarget.dataset.url;
    form.method = "POST"
    form.submit();
  }
}
